class BrowserDetect
  constructor: ->
    @browser = @searchString(@dataBrowser) || 'unknown-browser'
    @version = @searchVersion(navigator.userAgent) || @searchVersion(navigator.appVersion) || 'unknown-browser-version'
    @OS = @searchString(@dataOS) || 'unknown-os'
    return
  searchString: (data) ->
    for datum in data
      @versionSearchString = datum.versionSearch || datum.identity
      if (datum.string && datum.string.indexOf(datum.subString) != -1) || datum.prop
        return datum.identity
    return
  searchVersion: (dataString) ->
    index = dataString.indexOf(@versionSearchString)
    if index == -1
      return
    return parseFloat(dataString.substring(index + @versionSearchString.length + 1))
  dataBrowser: [
    {
      string: navigator.userAgent
      subString: 'Chrome'
      identity: 'Chrome'
    }
    {
      string: navigator.userAgent
      subString: 'OmniWeb'
      versionSearch: 'OmniWeb/'
      identity: 'OmniWeb'
    }
    {
      string: navigator.vendor
      subString: 'Apple'
      identity: 'Safari'
      versionSearch: 'Version'
    }
    {
      prop: window.opera
      identity: 'Opera'
    }
    {
      string: navigator.vendor
      subString: 'iCab'
      identity: 'iCab'
    }
    {
      string: navigator.vendor
      subString: 'KDE'
      identity: 'Konqueror'
    }
    {
      string: navigator.userAgent
      subString: 'Firefox'
      identity: 'Firefox'
    }
    {
      string: navigator.vendor
      subString: 'Camino'
      identity: 'Camino'
    }
    { # for newer Netscapes (6+)
      string: navigator.userAgent
      subString: 'Netscape'
      identity: 'Netscape'
    }
    {
      string: navigator.userAgent
      subString: 'MSIE'
      identity: 'Explorer'
      versionSearch: 'MSIE'
    }
    {
      string: navigator.userAgent
      subString: 'Trident/7'
      identity: 'Explorer'
      versionSearch: 'rv'
    }
    {
      string: navigator.userAgent
      subString: 'Gecko'
      identity: 'Mozilla'
      versionSearch: 'rv'
    }
    { # for older Netscapes (4-)
      string: navigator.userAgent
      subString: 'Mozilla'
      identity: 'Netscape'
      versionSearch: 'Mozilla'
    }
  ]
  dataOS: [
    {
      string: navigator.platform
      subString: 'Win'
      identity: 'Windows'
    }
    {
      string: navigator.platform
      subString: 'Mac'
      identity: 'Mac'
    }
    {
      string: navigator.userAgent
      subString: 'iPhone'
      identity: 'iPhone'
    }
    {
      string: navigator.userAgent
      subString: 'iPod'
      identity: 'iPod'
    }
    {
      string: navigator.userAgent
      subString: 'iPad'
      identity: 'iPad'
    }
    {
      string: navigator.userAgent
      subString: 'Android'
      identity: 'Android'
    }
    {
      string: navigator.platform
      subString: 'Linux'
      identity: 'Linux'
    }
  ]

module.exports = new BrowserDetect()



// WEBPACK FOOTER //
// ./app/scripts/lib/browser-detect.coffee